import { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer";
import axios from "../../../axios";
import AccountModal from "./AccountModal/AccountModal";

const columns = [
  { name: "Name", selector: "name", sortable: true, style: { fontSize: "15px" }},
  { name: "E-mail", selector: "email", sortable: true, style: { fontSize: "14px" }},
  { name: "Account Number", selector: "accountNumber", sortable: true, style: { fontSize: "14px" }},
  { name: "Company", selector: "companyName", sortable: true, style: { fontSize: "14px" }},
]

class Accounts extends Component {

  state = {
    accounts: [],
    selectedAccount: null,
    showAccountModal: false
  }

  componentDidMount() {
    this.loadAccounts();
  }

  loadAccounts = () => {
    axios.get("/platforms/accounts")
      .then(response => {
        if (response.data && response.data.accounts) {
          this.setState({ accounts: response.data.accounts });
        }
      })
      .catch(err => {
        console.error("Failed to load accounts:", err);
      });
  }

  closeModal = () => {
    // Close the modal in state
    this.setState({ showAccountModal: false, selectedAccount: null });

    // Refresh the list
    setTimeout(() => {
      this.loadAccounts();
    }, 500);
  }

  render() {
    return (
      <ContentContainer title="Accounts">
        <DataTable
          columns={columns}
          data={this.state.accounts}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"name"}
          defaultSortAsc={false}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" }}
          }}
          onRowClicked={(account) => this.setState({ showAccountModal: true, selectedAccount: account })}
        />

        {this.state.showAccountModal && (
          <AccountModal
            shouldShow={this.state.showAccountModal}
            selectedAccount={this.state.selectedAccount}
            closeModal={() => this.closeModal()}
          />
        )}
      </ContentContainer>
    );
  }
}

export default Accounts;
